export interface INavigationRoute {
  id?: any
  name: string
  displayName: string
  description?: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    // {
    //   name: 'users',
    //   displayName: 'menu.users',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },

    {
      name: 'tutor-programs',
      displayName: 'menu.tutor-programs',
      meta: {
        icon: 'local_library', // Assuming an icon for adding programs
      },
    },
    {
      name: 'tutor-module-to-program',
      displayName: 'menu.tutor-module-to-program',
      meta: {
        icon: 'view_module', // Assuming an icon for adding module to program
      },
    },
    {
      name: 'tutor-sub-module',
      displayName: 'menu.tutor-sub-module',
      meta: {
        icon: 'view_stream', // Assuming an icon for adding sub-module
      },
    },
    {
      name: 'tutor-lesson-to-sub-module',
      displayName: 'menu.tutor-lesson-to-sub-module',
      meta: {
        icon: 'cast_for_education', // Assuming an icon for adding lesson to sub-module
      },
    },

    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
